// extracted by mini-css-extract-plugin
export default {"title":"styles_title__YGIWT","address":"styles_address__H5fPz","gpsInfoWindow":"styles_gpsInfoWindow__9kzYD","loading":"styles_loading__ZLw7G"};